var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ruleStr)?_c('div',{staticClass:"scroll-y activity-page"},[_c('div',{staticClass:"activity-title"},[_vm._v("规则说明")]),_c('div',{staticClass:"activity-detail",domProps:{"innerHTML":_vm._s(_vm.ruleStr)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }